import { Point } from 'shared/chart/core/types';
import { ChartExportColors } from 'utils/colors';

const ChartTooltipXOffsetPx = 15;
const ChartTooltipCursorXOffsetPx = 10;

export const MaxTooltipDigits = 4;

export const MaxMarkerHarmonicCount = 128;

export const getTrendChartTooltipPosition = ({ x, y }: Point) => {
    const halfWidth = window.innerWidth / 2;
    const halfHeight = window.innerHeight / 2;

    return {
        left:
            x <= halfWidth
                ? x + ChartTooltipXOffsetPx + ChartTooltipCursorXOffsetPx
                : undefined,
        right: x > halfWidth ? window.innerWidth - x + ChartTooltipXOffsetPx : undefined,
        top: y <= halfHeight ? y : undefined,
        bottom: y > halfHeight ? window.innerHeight - y : undefined,
    };
};

export const ChartMarkerPrimaryLabelFont = {
    fontFamily: 'REM',
    fontSizePx: 13,
};

export const ChartMarkerSecondaryLabelFont = {
    fontFamily: 'REM',
    fontSizePx: 10,
};

export const ChartMarkerLabelFontColor = ChartExportColors.labelFontColor;
